import React, { useState, useEffect } from 'react';
import { Progress } from 'antd';

const Running = () => {
    const [percent, setPercent] = useState(0);

    useEffect(() => {
        const interval = setInterval(() => {
            setPercent((prevPercent) => (prevPercent + 20 <= 100 ? prevPercent + 20 : 100));
        }, 300);

        // Cleanup function to clear the interval
        return () => clearInterval(interval);
    }, []);

    const renderText = () => {
        return "Calculating Mileage"
    };

    const renderSubText = () => {
        if (percent < 100) {
            return "This can take up to 30 seconds";
        } else {
            return "Sorry, just a few more bits";
        }
    };

    // #52449D

    return (
        <div className="running">
            <div className="icon">
                <Progress strokeColor={"#FFD100"} trailColor='#fff' type="circle" percent={percent} />
            </div>
            <div>
                <div className="text">{renderText()}</div>
                <div style={{ fontSize: 12 }}>{renderSubText()}</div>
            </div>
        </div>
    );
};

export default Running;
